/**
 * Hidden decoy fields that absorb password-manager autofill (Firefox built-in is the main target).
 * Render this *first inside* sensitive forms — most managers fill the first email/password they
 * find, which is now a no-op input that we never read.
 */
export function AntiAutofillHoneypot() {
  return (
    <div aria-hidden="true" className="absolute h-0 w-0 overflow-hidden opacity-0">
      <input type="text" name="email" tabIndex={-1} autoComplete="username" />
      <input type="password" name="password" tabIndex={-1} autoComplete="current-password" />
    </div>
  );
}
